// extracted by mini-css-extract-plugin
export default {"root":"base-input_root_Wf1rv","hasError":"base-input_hasError_Dp0SR"};